(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("cb-components-common"));
	else if(typeof define === 'function' && define.amd)
		define("cb-components-portfolio-analysis", ["cb-components-common"], factory);
	else if(typeof exports === 'object')
		exports["cb-components-portfolio-analysis"] = factory(require("cb-components-common"));
	else
		root["cb-components-portfolio-analysis"] = factory(root["cb-components-common"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE_cb_components_common__) {
return 